import { type SelectDataObject } from '../_tools/inputfields/Select';

const sIntBattery: SelectDataObject[] = [
    { i: 0, t: '(unbekannt)' },
    { i: 1, t: 'enthalten/Miete' },
    { i: 2, t: 'inklusive' },
    { i: 3, t: 'ohne' },
];
export default sIntBattery;
